/* RJ October 2026 CRO — sticky add to cart and quick filter chips. */
(function () {
  'use strict';

  /* ---------- Mobile sticky add to cart ----------
     Drives the page's real Add to Cart button, so variant, bundle and cart-drawer logic all stay the theme's own.
     If the product has a size option and the shopper has not chosen one, the bar asks for a size instead of adding. */
  if (!customElements.get('rj-sticky-atc')) {
    class RjStickyAtc extends HTMLElement {
      connectedCallback() {
        // The bar lives in its own section, so find the main product form on the page.
        // Use getAttribute('id'): the form has an <input name="id">, so form.id returns that input, not the id string.
        var forms = document.querySelectorAll('.main-product-page form[id^="product-form-"], form[data-type="add-to-cart-form"][id^="product-form-"]');
        this.form = Array.prototype.find.call(forms, function (f) { return f.querySelector('[name="add"]'); }) || null;
        this.sectionId = this.form ? this.form.getAttribute('id').replace('product-form-', '') : '';
        this.mainBtn = this.form && this.form.querySelector('[name="add"]');
        if (!this.form || !this.mainBtn) { this.hidden = true; return; }
        this.btn = this.querySelector('.rj-sticky__btn');
        this.priceEl = this.querySelector('.rj-sticky__price');
        this.metaEl = this.querySelector('.rj-sticky__meta');
        this.selects = document.getElementById('variant-selects-' + this.sectionId);
        this.sizeFieldset = this.selects
          ? Array.prototype.find.call(this.selects.querySelectorAll('fieldset[data-handle]'), function (f) { return /size/.test(f.dataset.handle); })
          : null;
        this.sizeChosen = !this.sizeFieldset || new URL(window.location.href).searchParams.has('variant');
        this.mainInView = false;

        var self = this;
        if (this.sizeFieldset) {
          this.sizeFieldset.addEventListener('change', function () { self.sizeChosen = true; self.clearPrompt(); self.sync(); });
        }
        if (this.selects) this.selects.addEventListener('change', function () { setTimeout(function () { self.sync(); }, 200); });
        this.btn.addEventListener('click', this.onClick.bind(this));

        this.io = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) { self.mainInView = e.isIntersecting; });
          self.toggle();
        }, { threshold: 0 });
        this.io.observe(this.mainBtn);

        this.mo = new MutationObserver(function () { self.sync(); });
        this.mo.observe(this.mainBtn, { attributes: true, attributeFilter: ['disabled', 'class'], childList: true, characterData: true, subtree: true });
        var price = document.getElementById('price-' + this.sectionId);
        if (price) this.mo.observe(price, { childList: true, subtree: true, characterData: true });
        this.sync();
      }
      disconnectedCallback() {
        if (this.io) this.io.disconnect();
        if (this.mo) this.mo.disconnect();
        document.body.classList.remove('rj-sticky-on');
      }
      toggle() {
        var show = !this.mainInView;
        this.classList.toggle('is-visible', show);
        this.setAttribute('aria-hidden', show ? 'false' : 'true');
        this.btn.tabIndex = show ? 0 : -1;
        document.body.classList.toggle('rj-sticky-on', show);
      }
      selectedSummary(skipSize) {
        if (!this.selects) return '';
        var parts = [];
        var sizeFs = this.sizeFieldset;
        this.selects.querySelectorAll('fieldset').forEach(function (fs) {
          if (skipSize && fs === sizeFs) return;
          var checked = fs.querySelector('input:checked');
          var select = fs.querySelector('select');
          var v = checked ? checked.value : (select ? select.value : '');
          if (v) parts.push(v);
        });
        return parts.join(' · ');
      }
      currentPrice() {
        var price = document.getElementById('price-' + this.sectionId);
        if (!price) return '';
        var el = price.querySelector('ins .amount') || price.querySelector('.amount') || price;
        return (el.textContent || '').replace(/\s+/g, ' ').trim();
      }
      sync() {
        var disabled = this.mainBtn.disabled || this.mainBtn.classList.contains('sold-out');
        var label;
        if (disabled) {
          label = (this.mainBtn.textContent || '').replace(/\s+/g, ' ').trim() || 'Sold out';
        } else if (!this.sizeChosen) {
          label = this.dataset.chooseLabel || 'Choose size';
        } else {
          label = this.dataset.addLabel || 'Add to cart';
        }
        this.btn.textContent = label;
        this.btn.disabled = disabled;
        this.btn.setAttribute('aria-label', label);
        if (this.priceEl) this.priceEl.textContent = this.currentPrice();
        if (this.metaEl) {
          var summary = this.selectedSummary(!this.sizeChosen);
          this.metaEl.textContent = summary;
          this.metaEl.hidden = !summary;
        }
      }
      clearPrompt() {
        if (!this.sizeFieldset) return;
        this.sizeFieldset.classList.remove('rj-size-prompt');
        var hint = this.sizeFieldset.querySelector('.rj-size-hint');
        if (hint) hint.remove();
      }
      onClick() {
        if (this.btn.disabled) return;
        if (!this.sizeChosen && this.sizeFieldset) {
          var fs = this.sizeFieldset;
          fs.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'center' });
          fs.classList.add('rj-size-prompt');
          if (!fs.querySelector('.rj-size-hint')) {
            var hint = document.createElement('span');
            hint.className = 'rj-size-hint';
            hint.setAttribute('role', 'status');
            hint.textContent = this.dataset.sizeHint || 'Please choose your size';
            fs.appendChild(hint);
          }
          var first = fs.querySelector('input:checked, input, select');
          if (first) setTimeout(function () { first.focus({ preventScroll: true }); }, 400);
          return;
        }
        this.mainBtn.click();
      }
    }
    customElements.define('rj-sticky-atc', RjStickyAtc);
  }

  /* ---------- Estimated delivery ----------
     All dates are worked out in UK time (Europe/London), counting working days only
     (Mon-Fri, excluding the holiday list in snippets/rj-delivery-estimate.liquid). Always "estimated". */
  if (!customElements.get('rj-delivery-estimate')) {
    var DAY = 86400000;
    var londonNow = function () {
      var parts = {};
      new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/London', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', hourCycle: 'h23' })
        .formatToParts(new Date()).forEach(function (p) { parts[p.type] = p.value; });
      return { date: Date.UTC(+parts.year, +parts.month - 1, +parts.day), hour: +parts.hour, minute: +parts.minute };
    };
    var iso = function (t) { return new Date(t).toISOString().slice(0, 10); };
    var fmt = function (t, withDay) {
      return new Intl.DateTimeFormat('en-GB', { timeZone: 'UTC', weekday: withDay ? 'short' : undefined, day: 'numeric', month: 'short' }).format(new Date(t));
    };
    class RjDeliveryEstimate extends HTMLElement {
      connectedCallback() {
        this.holidays = (this.dataset.holidays || '').split(',').map(function (s) { return s.trim(); });
        this.render();
        var self = this;
        this.timer = setInterval(function () { self.render(); }, 60000);
      }
      disconnectedCallback() { clearInterval(this.timer); }
      isWorking(t) { var d = new Date(t).getUTCDay(); return d !== 0 && d !== 6 && this.holidays.indexOf(iso(t)) === -1; }
      nextWorking(t) { var x = t + DAY; while (!this.isWorking(x)) x += DAY; return x; }
      addWorking(t, n) { var x = t; for (var i = 0; i < n; i++) x = this.nextWorking(x); return x; }
      render() {
        var now = londonNow();
        var cutoff = parseInt(this.dataset.cutoff, 10) || 15;
        var today = now.date;
        var sameDay = this.isWorking(today) && now.hour < cutoff;
        var dispatch = sameDay ? today : this.nextWorking(today);
        var min = parseInt(this.dataset.min, 10) || 2;
        var max = parseInt(this.dataset.max, 10) || 3;
        var from = this.addWorking(dispatch, min);
        var to = this.addWorking(dispatch, max);

        var dispatchEl = this.querySelector('[data-rj-dispatch]');
        if (sameDay) {
          var mins = (cutoff * 60) - (now.hour * 60 + now.minute);
          var h = Math.floor(mins / 60), m = mins % 60;
          dispatchEl.innerHTML = 'Order within <strong>' + (h ? h + 'h ' : '') + m + 'm</strong> for dispatch today';
        } else {
          var tomorrow = today + DAY;
          dispatchEl.innerHTML = 'Order now for dispatch <strong>' + (dispatch === tomorrow ? 'tomorrow' : 'on ' + fmt(dispatch, true)) + '</strong>';
        }
        var arrive = this.querySelector('[data-rj-arrive]');
        arrive.innerHTML = 'Estimated delivery <strong>' + fmt(from, true) + ' – ' + fmt(to, true) + '</strong>';
        arrive.hidden = false;

        var xmas = this.querySelector('[data-rj-xmas]');
        var last = this.dataset.xmas;
        if (xmas && last && this.dataset.uk === '1') {
          var lastT = Date.parse(last + 'T00:00:00Z');
          if (!isNaN(lastT) && today <= lastT && today >= lastT - 45 * DAY) {
            xmas.textContent = 'Order by ' + fmt(lastT, true) + ' for estimated UK delivery before Christmas.';
            xmas.hidden = false;
          } else { xmas.hidden = true; }
        }
      }
    }
    customElements.define('rj-delivery-estimate', RjDeliveryEstimate);
  }

  /* Mobile Filter button: opens the theme's existing filter panel. */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-rj-open-filters]');
    if (!btn) return;
    var modal = document.getElementById(btn.getAttribute('data-rj-open-filters'));
    if (modal && typeof modal.show === 'function') { e.preventDefault(); modal.show(btn); }
  });

  /* ---------- Quick filter chips ----------
     A chip can stand for several Search & Discovery values (e.g. "Adjustable" and "adjustable").
     Clicking rebuilds the URL so other active filters and the sort order are kept. */
  document.addEventListener('click', function (e) {
    var chip = e.target.closest && e.target.closest('[data-rj-chip]');
    if (!chip) return;
    e.preventDefault();
    var url = new URL(window.location.href);
    var params = url.searchParams;
    var name = chip.getAttribute('data-param');
    var values = (chip.getAttribute('data-values') || '').split('||').filter(Boolean);
    var active = chip.classList.contains('is-active');
    var keep = params.getAll(name).filter(function (v) { return values.indexOf(v) === -1; });
    params.delete(name);
    keep.forEach(function (v) { params.append(name, v); });
    if (!active) values.forEach(function (v) { params.append(name, v); });
    params.delete('page');
    window.location.href = url.pathname + (params.toString() ? '?' + params.toString() : '');
  });
  /* ---------- Filter drawer (rj-facet-groups) ----------
     1) Merged options: one visible checkbox can stand for several Search & Discovery values (hidden twins).
        Keep the twins in step; the theme's form listener (debounced 500ms) then submits them together.
     2) Quick price bands fill the theme's own min/max price inputs and fire the same 'input' event the slider uses.
     Delegated listeners on document: safe when the drawer is re-rendered by facets.js or absent on a page. */
  document.addEventListener('change', function (e) {
    var box = e.target;
    if (!box || !box.matches || !box.matches('input[data-rj-twins]')) return;
    box.getAttribute('data-rj-twins').split(',').forEach(function (id) {
      var twin = document.getElementById(id);
      if (twin) twin.checked = box.checked;
    });
  });
  document.addEventListener('click', function (e) {
    var band = e.target.closest && e.target.closest('[data-rj-price-band]');
    if (!band) return;
    e.preventDefault();
    var form = band.closest('form');
    if (!form) return;
    var min = form.querySelector('input[name="filter.v.price.gte"]');
    var max = form.querySelector('input[name="filter.v.price.lte"]');
    if (!min || !max) return;
    var on = band.classList.contains('is-active');
    min.value = on ? '' : (band.getAttribute('data-min') || '');
    max.value = on ? '' : (band.getAttribute('data-max') || '');
    var all = form.querySelectorAll('[data-rj-price-band]');
    for (var i = 0; i < all.length; i++) { all[i].classList.remove('is-active'); all[i].setAttribute('aria-pressed', 'false'); }
    if (!on) { band.classList.add('is-active'); band.setAttribute('aria-pressed', 'true'); }
    max.dispatchEvent(new Event('input', { bubbles: true }));
  });
})();
